export enum InviteLinkDispatchType {
  WebLink = 'webLink',
  Email = 'email',
  TextMessage = 'textMessage',
  SocialMedia = 'socialMedia',
  Website = 'website',
}
